<style>
@import '../../custom/css/cotacao.css';
</style>

<template>
  <div id="cotacao-resposta" class="cotacao" v-if="this.cotacao !== null">
    <div class="row m-0">
      <div class="col-12">
        <h1 class="title font-weight-bold text-uppercase">
          Cotação de Resposta
        </h1>
        <hr class="linha-amarela" />
      </div>
      <div class="col-12">
        <div class="card-cotacao">
          <div class="cc-header d-flex">
            <div class="cc-sub-title m-r-25">
              <img
                class="imagem-archive-cotacao"
                src="@/assets/img/icons/file-archive.png"
              />
            </div>
            <div
              class="cc-sub-title d-flex align-items-center"
              v-if="this.cotacao[0].atualizado_em !== null"
            >
              <div>
                Data:
                <div class="cc-sub-result">
                  {{ this.cotacao[0].atualizado_em }}
                </div>
              </div>
              <div class="cc-sub-line"></div>
              <div class="cc-sub-title d-flex align-items-center">
                <div v-if="this.cotacao[0].cot_cotacao_id !== null">
                  Cód:
                  <div class="cc-sub-result">
                    {{ this.cotacao[0].cot_cotacao_id }}
                  </div>
                </div>
              </div>
              <div class="cc-sub-line"></div>
              <div class="cc-sub-title d-flex align-items-center">
                <div>
                  Preferência:
                  <div class="cc-sub-result">
                    {{ this.cotacao[0].cot_preferencia }}
                  </div>
                </div>
              </div>
              <div class="cc-sub-line"></div>
              <div class="cc-sub-title d-flex align-items-center">
                <div>
                  Situação:
                  <div class="cc-sub-result">
                    <div v-if="this.cotacao[0].cot_status_id === 3">
                      Rejeitado
                    </div>
                    <div v-else-if="this.cotacao[0].cot_status_id === 4">
                      Respondido
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cc-content p-0" v-if="this.cotacao[0].produtos !== null">
            <div class="table-responsive">
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome</th>
                    <th class="th">Marca</th>
                    <th class="th">Medida</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Undidade</th>
                    <th class="th">Subtotal</th>
                    <th class="th">Disponível</th>
                    <th class="th">Rejeitado</th>
                    <th class="th">Dúvidas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in this.cotacao[0].produtos"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div v-if="produto.disponivel == true">
                        {{ produto.produto_nome }}
                      </div>
                      <div v-else>Não tem {{ produto.produto_nome }}</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div v-if="produto.marca_nome">
                        {{ produto.marca_nome }}
                      </div>
                      <div v-else>Sem Marca</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div v-if="produto.tipo_medida_nome">
                        {{ produto.tipo_medida_nome }}
                      </div>
                      <div v-else>Sem Medida</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      {{ produto.qtd_quantidade }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      {{ produto.preco_unidades }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      {{ produto.preco_total }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div v-if="produto.disponivel == true">Sim</div>
                      <div v-else>Sim</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div v-if="produto.rejeitar == true">Sim</div>
                      <div v-else>Sim</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="cc-content p-0"
            v-if="this.cotacao[0].produtosImagemArquivo !== null"
          >
            <div class="table-responsive">
              <table class="table table-pedidos">
                <thead>
                  <tr class="tr fs-12">
                    <th class="th">Item</th>
                    <th class="th">Nome do produto</th>
                    <th class="th">Quantidade</th>
                    <th class="th">Preço</th>
                    <th class="th">Subtotal</th>
                    <th class="th">Comentarios</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="tr fs-14"
                    v-for="(produto, index) in this.cotacao[0]
                      .produtosImagemArquivo"
                    :key="index"
                  >
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      {{ index + 1 }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div v-if="produto.disponivel == true">
                        {{ produto.produto_nome }}
                      </div>
                      <div v-else>Não tem {{ produto.produto_nome }}</div>
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      {{ produto.qtd_quantidade }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      {{ produto.preco_unidades }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      {{ produto.preco_total }}
                    </td>
                    <td
                      v-bind:class="
                        'td' + [produto.disponivel == true ? '' : ' red-font']
                      "
                    >
                      <div
                        class="btn-message"
                        @click="
                          verMensagens(
                            dadosUsuario.id,
                            produto.id,
                            cotacao[0].cot_usuario_respondeu_id
                          )
                        "
                      >
                        <i class="fas fa-envelope"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="cc-content">
            <div class="row m-0">
              <div class="col-4 p-0" v-if="checkIsEmpty(this.cotacao[0].cep)">
                <b class="font-weight-bold text-uppercase fs-14"
                  >Retira na loja</b
                >
              </div>
              <div class="col-4 p-0" v-else>
                <b class="font-weight-bold text-uppercase fs-14"
                  >CEP de entrega: {{ this.cotacao[0].cep }}</b
                >
              </div>
              <div class="col-4 p-0 text-right">
                <b class="font-weight-bold text-uppercase fs-14">Frete:</b>
                {{ this.cotacao[0].cot_frete }}
              </div>
              <div class="col-4 p-0 text-right">
                <b class="font-weight-bold text-uppercase fs-14"
                  >Prazo de entrega:</b
                >
                {{ this.cotacao[0].cot_prazo }}
              </div>
            </div>
          </div>
          <div class="cc-content">
            <div class="prazo-entrega text-right">
              <b class="font-weight-bold text-uppercase fs-14">Valor Total:</b>
              {{ this.cotacao[0].cot_valor_total }}
            </div>
          </div>
          <div class="cc-content">
            <div class="condicoes-pagamento-entrega">
              <b class="font-weight-bold text-uppercase fs-14"
                >Condições de Pagamento:</b
              >
              {{ this.cotacao[0].cot_cond_pagamentos }}
            </div>
          </div>
          <div class="cc-content" v-if="this.cotacao[0].cot_status_id === 3">
            <div class="condicoes-pagamento-entrega">
              <b class="font-weight-bold text-uppercase fs-14">Rejeição:</b>
              {{ this.cotacao[0].cot_motivo_rejeicao }}
            </div>
          </div>
          <div class="cc-footer">
            <div
              class="position-relative row m-0 p-10 text-right linha-abaixo-cinza"
            >
              <div class="col-12 p-0 text-right">
                <div class="btn-voltar" @click="voltarCotacao()">Voltar</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="comentarios" ref="comentarios" title="Comentarios" hide-footer>
      <template slot="modal-title">Comentarios sobre esse produto</template>
      <div class="d-block text-center">
        <div class="limit_comentarios">
          <div
            class="comentarios_mensagens"
            v-for="(mensagem, index) in mensagensCotacao"
            :key="index"
          >
            <div
              class="row m-0"
              v-if="mensagem.usuario_enviador_id !== dadosUsuario.id"
            >
              <div class="tipo col-3 p-0">
                {{ mensagem.usuario_enviador.tipo_usuario.nome }}
              </div>
              <div class="mensagem col-9 p-0 text-left fs-14">
                {{ mensagem.mensagem }}
              </div>
            </div>
            <div class="row m-0" v-else>
              <div class="mensagem col-9 p-0 text-right fs-14">
                {{ mensagem.mensagem }}
              </div>
              <div class="tipo col-3 p-0">
                {{ mensagem.usuario_enviador.tipo_usuario.nome }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('comentarios')"
        >Fechar</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'cotacao-resposta',
  data: () => ({
    items: [],
    errors: [],
    produtosSA: null,
    mensagem: null,
    mensagemProdId: null,
    motivo: {
      valor: null,
      mensagem: null,
      class: 'form-control',
    },
  }),
  props: ['id'],
  created() {
    this.$store.dispatch('startLoader');
    this.$store
      .dispatch('showCotacaoRespondida', this.id)
      .then(() => {
        setTimeout(() => {
          if (this.cotacao !== null) {
            if (this.cotacao[0].produtos != null) {
              this.produtosSA = this.cotacao[0].produtos;
            } else if (this.cotacao[0].produtosImagemArquivo !== null) {
              this.produtosSA = this.cotacao[0].produtosImagemArquivo;
            }
          }
          this.$store.dispatch('endLoader');
        }, 500);
      })
      .catch(() => {
        this.$store.dispatch('endLoader');
      });
  },
  computed: {
    ...mapGetters(['getTipoNotification', 'getNotification']),
    ...mapState({
      cotacao: (state) => state.cotacao,
      dadosUsuario: (state) => state.dadosUsuario,
      mensagensCotacao: (state) => state.mensagensCotacao,
    }),
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    voltarCotacao() {
      this.$router.push({
        name: 'administrador-cotacoes-geral',
      });
    },
    verMensagens(UsuarioEnviador, produtoId, UsuarioRecebedor) {
      this.mensagemProdId = produtoId;
      this.$store
        .dispatch('showMensagensCotacaoResposta', produtoId)
        .then(() => {
          this.$bvModal.show('comentarios');
        });
    },
    retirarAvisos() {
      this.errors = [];
      this.motivo.class = 'form-control';
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
